import MasterModel from '@/modules/core/MasterModel.js';

const model = 'ResClientes';

export default {
  list(params, callback) {
    MasterModel.get(model, params, callback);
  },
  getClientes(params, callback) {
    MasterModel.get(model+"/ClientesByPhone/"+params, {}, callback);
  },
  save(params, callback) {

  },
  delete(params) {

  },
  loadAll() {

  },
};
